import React from "react";

import { Container } from "@mui/material";
import ReportList from "../components/reports/ReportList";
import HeaderHelpPage from "../components/HeaderHelpPage";

const Report = (props) => {
  return (
    <Container>
      <HeaderHelpPage title="Report" description="Review report generated for Merchant" />
      <ReportList />
    </Container>
  );
};

export default Report;
